var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "#B5B8C5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V16C0 17.1 0.9 18 2 18H6L8.29 20.29C8.68 20.68 9.31 20.68 9.7 20.29L12 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM10 16H8V14H10V16ZM12.07 8.25L11.17 9.17C10.59 9.76 10.18 10.27 10.05 11.23C9.99 11.66 9.64 11.99 9.2 11.99H8.89C8.76706 11.9898 8.64559 11.9632 8.5338 11.912C8.422 11.8609 8.32247 11.7864 8.24191 11.6935C8.16136 11.6006 8.10165 11.4916 8.06682 11.3736C8.03199 11.2557 8.02285 11.1317 8.04 11.01C8.15 10.1 8.57 9.29 9.18 8.67L10.42 7.41C10.78 7.05 11 6.55 11 6C11 4.9 10.1 4 9 4C8.13 4 7.38 4.57 7.11 5.35C6.98 5.72 6.67 5.99 6.28 5.99H5.98C5.4 5.99 5 5.43 5.16 4.87C5.43251 3.94761 6.02811 3.15421 6.83776 2.63503C7.6474 2.11585 8.61695 1.90563 9.56892 2.04284C10.5209 2.18005 11.3916 2.65551 12.0217 3.3822C12.6518 4.10889 12.9991 5.03819 13 6C13 6.88 12.64 7.68 12.07 8.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.274f812641bc6cb620c149f75188e50d.svg";
export { ForwardRef as ReactComponent };